// Write your code here.
import './index.css'

const WinOrLoseCard = props => {
  const {isWon, onClickPlayAgain, score} = props

  const onClickY = () => {
    onClickPlayAgain()
  }

  let element
  if (isWon) {
    element = (
      <div className="win-lose-card">
        <div className="win-lose-details">
          <h1 className="win-lose-heading">You Won</h1>
          <p className="best-score">Best Score</p>
          <p className="final-score">{score}/12</p>
          <button
            className="button-play-again"
            type="button"
            onClick={onClickY}
          >
            Play Again
          </button>
        </div>
        <img
          src="https://assets.ccbp.in/frontend/react-js/won-game-img.png"
          className="win-lose-img"
          alt="win or lose"
        />
      </div>
    )
  } else {
    element = (
      <div className="win-lose-card">
        <div className="win-lose-details">
          <h1 className="win-lose-heading">You Lose</h1>
          <p className="best-score">Score</p>
          <p className="final-score">{score}/12</p>
          <button
            className="button-play-again"
            type="button"
            onClick={onClickY}
          >
            Play Again
          </button>
        </div>
        <img
          src="https://assets.ccbp.in/frontend/react-js/lose-game-img.png"
          className="win-lose-img"
          alt="win or lose"
        />
      </div>
    )
  }
  return element
}

export default WinOrLoseCard
